import { useSelector } from "./useSelector";

const useParameterOpening = () => {
    const selector = useSelector(state => state?.canOpenParametersUntil)
    return selector;
}

export default useParameterOpening;